import axios from 'axios'
import Cookie from 'js-cookie'

import { GetConsultationResponse } from './types'

import { isBrowser } from '@/utils/common'

export async function getConsultation(
  consultationId: string,
  headers?: { [key: string]: string },
): Promise<GetConsultationResponse> {
  headers = headers ?? { Authorization: Cookie.get('token') ?? '' }
  const baseURL = isBrowser() ? '/' : 'http://127.0.0.1:3000'

  const result = await axios({
    method: 'GET',
    url: `/api/v2/consultation/${consultationId}`,
    baseURL,
    headers,
  })

  return result.data.data
}
